import * as Sentry from "@sentry/react";
import { ENV } from "./env";

// Friend invite links carry a private token in the path; never send it.
const INVITE_PATH = /(\/|%2f)invite(\/|%2f)[^/?#&\s"%]*/gi;
function scrub<T>(event: T): T {
  try {
    return JSON.parse(JSON.stringify(event).replace(INVITE_PATH, "/invite")) as T;
  } catch {
    return event;
  }
}

// Error monitoring is a SynthOS platform default. Guarded so an empty DSN is a
// safe no-op (e.g. local dev without the var baked in).
export function initSentry() {
  if (!ENV.sentryDsn) return;
  try {
    Sentry.init({
      dsn: ENV.sentryDsn,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1,
      environment: import.meta.env.MODE,
      beforeSend: (event) => scrub(event),
      beforeSendTransaction: (event) => scrub(event),
      beforeBreadcrumb: (crumb) => scrub(crumb),
    });
  } catch {
    /* never let monitoring setup break the page */
  }
}
